import { FaUpload } from 'react-icons/fa';
import { ChangeEvent, FC, useRef } from 'react';

import { processUploadFileEvent } from '../../lib';
import { convertToDataIdAttr } from '@shared/lib/utils/text.util';

import { buttonStyle, contentStyle } from './SecondaryUploadButton.tailwind';

interface PropsType {
  text: string;
  exts: string;
  onUpload: (file: File) => void;
}

const SecondaryUploadButton: FC<PropsType> = ({ text, exts, onUpload }) => {
  const ref = useRef<HTMLInputElement>(null);

  const handleUpload = (event: ChangeEvent<HTMLInputElement>) => {
    processUploadFileEvent(event, exts, onUpload);
  };

  return (
    <button
      className={buttonStyle}
      onClick={() => ref.current?.click()}
      data-id={`button-${convertToDataIdAttr(text)}`}
    >
      <div className={contentStyle}>
        <p>{text}</p>
        <FaUpload />
      </div>
      <input ref={ref} type="file" className="hidden" onChange={handleUpload} accept={exts} />
    </button>
  );
};

export default SecondaryUploadButton;
